<template>
  <LayoutsDefault
    class="main-content"
    :product-name="$t('support')"
    :sub-menu-items="subMenuItems"
    :product-path="localePath('/support')"
  >
    <slot />
  </LayoutsDefault>
</template>
<script lang="ts" setup>
import { useProductStore } from '~/store/product';

// -------------------------------------------
// Hooks
// -------------------------------------------
const localePath = useLocalePath();

// --------------------------------------
// Store
// --------------------------------------

const productStore = useProductStore(); 
const { product } = storeToRefs(productStore);


// -------------------------------------------
// Computed
// -------------------------------------------

const subMenuItems = computed(() => {
  if (product.value?.id) {
    return [{ title: product.value.name }]
  }

  return [];
})
</script>
